import { render, staticRenderFns } from "./AdminCalculationsTable.vue?vue&type=template&id=6627aae6&scoped=true&"
import script from "./AdminCalculationsTable.vue?vue&type=script&lang=js&"
export * from "./AdminCalculationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627aae6",
  null
  
)

export default component.exports